<template>
  <div class="flex justify-between h-full items-center">
    <button class="active:shadow" @click="toggleMenu">
      <db-icon icon="menu" variant="32-outline"></db-icon>
    </button>
    <app-title>{{ header }}</app-title>
    <div
      class="w-11"
      v-if="!isNotProduction"
      :class="store.state.TourStore?.slot ? 'h-14' : ''"
      @click="toggleSlotBook"
    >
      <ticket-multiple
        v-if="header == 'Tour' && !store.state.TourStore?.slot"
      ></ticket-multiple>
      <div
        class="absolute top-0 right-0 pt-2"
        v-else-if="header == 'Tour' && store.state.TourStore?.slot"
      >
        <div
          class="flex grow flex-col px-5 border-green-400 bg-green-100 rounded border-2 border-black justify-center items-center"
        >
          <span>{{ store.state.TourStore?.slot.date }}</span>
          <span>{{ store.state.TourStore?.slot.time }}</span>
        </div>
      </div>
    </div>
    <div class="w-11" v-else></div>
  </div>
</template>
<script setup>
import AppTitle from "@/components/AppTitle.vue";
import TicketMultiple from "@/components/icons/TicketMultiple.vue";
import store from "@/store";
import { DbIcon } from "@db-ui/v-elements-enterprise/dist/components";

defineProps(["header"]);
const toggleMenu = () => {
  store.dispatch("MenuStore/toggleMenu");
};
const toggleSlotBook = () => {
  if (!isNotProduction()) return;
  store.dispatch("TourStore/toggleSlotBook");
};

const isNotProduction = () => {
  return process.env.NODE_ENV !== "production";
};
</script>
